export default __webpack_public_path__ + "static/media/conteudo_extra_15_27.29538a9d.jpg";